import React, { createContext, useEffect, useState, ReactNode } from 'react';
import { appConfig } from '@libs/app.config';
import { Kochava } from 'kochava';
import { identifyUser } from '../helpers/analytics';
interface KochavaContextProps {
    kochava: Kochava | null;
}
export const KochavaContext = createContext<KochavaContextProps>({ kochava: null });
interface KochavaContextProviderProps {
    children: ReactNode;
}
const KochavaContextProvider: React.FC<KochavaContextProviderProps> = (props) => {
    const [kochava, setKochava] = useState<Kochava | null>(null);
    const kochavaKey = appConfig.kochavaKey;

    useEffect(() => {
        if (typeof window === 'undefined' || kochava || !kochavaKey) {
            return;
        }

        const kochavaLocal = Kochava.createForReact();
        kochavaLocal.startWithAppGuid(kochavaKey);
        identifyUser(kochavaLocal);
        setKochava(kochavaLocal);
    }, [kochava, kochavaKey]);

    return <KochavaContext.Provider value={{ kochava }}>{props.children}</KochavaContext.Provider>;
};
export default KochavaContextProvider;
